module.exports = __webpack_public_path__ + "img/3-3.66f6b426.png";